import app from './app/app'
import login from './login/login'


export default [
    app,
    login
]